/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "add-or-edit-combo-discount-group",
	data() {
		return {
			loadingFromApi: false,
			loading: false,
			comboDiscountGroupId: null,
			isEditMode: false,
			comboDiscountGroupAddEditForm: {
				comboDiscountGroup: {
					comboDiscountGroupId: null,
					isActive: true,
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					discountAmount: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					effectiveDate: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					linkedProducts: {
						value: [],
						hasError: false,
						errorMessage: null
					}
				}
			},
			productsToLinkHeadings: [
				{
					text: "Name",
					field: "name"
				},
				// {
				// 	text: "Original Price",
				// 	field: "originalPriceAsString"
				// },
				// {
				// 	text: "Discount Amount",
				// 	field: "discountAmountAsString"
				// },
				// {
				// 	text: "Price After Discount",
				// 	field: "priceAfterDiscountAsString"
				// },
				{
					text: "Apply Discount",
					field: "applyDiscountAsString"
				}
			],
			linkProductsToComboDiscountGroupModal: {
				showModal: false,
				isSaving: false,
				modalId: "linkProductsToComboDiscountGroupModal",
				heading: "Link Products To Combo Discount Group",
				comboDiscountGroupId: null
			},
			errorModal: {
				showModal: false,
				modalHeading: "Error",
				elementId: "errorModal",
				modalMessage: null
			},
			successModal: {
				showModal: false,
				modalHeading: "Success",
				elementId: "successModal",
				modalMessage: null
			},
			comboGroupProductsToSave: {}
		};
	},
	methods: {
		addOrUpdateComboDiscountGroup() {
			this.resetValidationErrors();
			if (this.validateForm()) {
				this.loading = true;
				let request = {
					comboDiscountGroupId: this.comboDiscountGroupId,
					name: this.comboDiscountGroupAddEditForm.comboDiscountGroup.name.value,
					discountAmount: this.comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.value,
					isActive: this.comboDiscountGroupAddEditForm.comboDiscountGroup.isActive,
					effectiveDate: this.comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.value,
					productsToLink: this.comboGroupProductsToSave.productsToLink ? this.comboGroupProductsToSave.productsToLink : [],
					productsToUnlink: this.comboGroupProductsToSave.productsToUnlink ? this.comboGroupProductsToSave.productsToUnlink : []
				};

				orderService.addOrUpdateComboDiscountGroup(request).then(
					successResponse => {
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if (isSuccess) {
							this.successModal.modalMessage = this.isEditMode ? "Combo Discount Group updated successfully." : "Combo Discount Group created successfully.";
							this.successModal.showModal = true;
						}
						this.loading = false;
					},
					errorResponse => {
						if (errorResponse.response.data.validationErrors && errorResponse.response.data.validationErrors.length > 0) {
							this.handleValidationErrors(errorResponse.response.data.validationErrors);
						} else {
							apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(errorResponse.response.data.responseStatus, errorResponse.response.data.httpStatusCode, errorResponse.response.data.message);
						}
						this.loading = false;
					}
				);
			}
		},
		validateForm() {
			let isValid = true;
			
			if (!this.comboDiscountGroupAddEditForm.comboDiscountGroup.name.value) {
				this.comboDiscountGroupAddEditForm.comboDiscountGroup.name.hasError = true;
				this.comboDiscountGroupAddEditForm.comboDiscountGroup.name.errorMessage = "Name is required.";
				isValid = false;
			}
			
			if (!this.comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.value || this.comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.value <= 0) {
				this.comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.hasError = true;
				this.comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.errorMessage = "Discount Amount must be greater than 0.";
				isValid = false;
			}
			
			if (!this.comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.value) {
				this.comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.hasError = true;
				this.comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.errorMessage = "Effective Date is required.";
				isValid = false;
			} else {
				// Check if effective date is not in the past
				const effectiveDate = new Date(this.comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.value);
				const today = new Date();
				today.setHours(0, 0, 0, 0); // Reset time to start of day for comparison
				
				if (effectiveDate < today) {
					this.comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.hasError = true;
					this.comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.errorMessage = "Effective Date cannot be in the past.";
					isValid = false;
				}
			}
			
			if (!this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value || this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value.length === 0) {
				this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.hasError = true;
				this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.errorMessage = "At least one product must be linked to the combo discount group.";
				isValid = false;
			}
			
			return isValid;
		},
		resetValidationErrors() {
			this.comboDiscountGroupAddEditForm.comboDiscountGroup.name.hasError = false;
			this.comboDiscountGroupAddEditForm.comboDiscountGroup.name.errorMessage = null;
			this.comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.hasError = false;
			this.comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.errorMessage = null;
			this.comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.hasError = false;
			this.comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.errorMessage = null;
			this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.hasError = false;
			this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.errorMessage = null;
		},
		handleValidationErrors(validationErrors) {
			for (let error of validationErrors) {
				if (error.property === "Name") {
					this.comboDiscountGroupAddEditForm.comboDiscountGroup.name.hasError = true;
					this.comboDiscountGroupAddEditForm.comboDiscountGroup.name.errorMessage = error.errorMessage;
				} else if (error.property === "DiscountAmount") {
					this.comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.hasError = true;
					this.comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.errorMessage = error.errorMessage;
				} else if (error.property === "EffectiveDate") {
					this.comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.hasError = true;
					this.comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.errorMessage = error.errorMessage;
				} else if (error.property === "LinkedProducts" || error.property === "ProductsToLink") {
					this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.hasError = true;
					this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.errorMessage = error.errorMessage;
				}
			}
		},
		loadComboDiscountGroup() {
			if (this.comboDiscountGroupId) {
				this.loadingFromApi = true;
				orderService.getComboDiscountGroup(this.comboDiscountGroupId).then(
					successResponse => {
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if (isSuccess) {
							const comboDiscountGroup = successResponse.data.result;
							this.comboDiscountGroupAddEditForm.comboDiscountGroup.name.value = comboDiscountGroup.name;
							this.comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.value = comboDiscountGroup.discountAmount;
							this.comboDiscountGroupAddEditForm.comboDiscountGroup.isActive = comboDiscountGroup.isActive;
							// Format the date for the date input (YYYY-MM-DD format)
							if (comboDiscountGroup.effectiveDate) {
								// Extract just the date portion to avoid timezone issues
								const dateString = comboDiscountGroup.effectiveDate.split('T')[0];
								this.comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.value = dateString;
							}
							this.loadComboDiscountGroupProducts();
						}
						this.loadingFromApi = false;
					},
					errorResponse => {
						apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(errorResponse.response.data.responseStatus, errorResponse.response.data.httpStatusCode, errorResponse.response.data.message);
						this.loadingFromApi = false;
					}
				);
			}
		},
		loadComboDiscountGroupProducts() {
			if (this.comboDiscountGroupId) {
				this.loadingFromApi = true;
				orderService.getComboDiscountGroupProductsByComboDiscountGroup(this.comboDiscountGroupId).then(
					successResponse => {
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if (isSuccess) {
							this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value = [];
							for(let i = 0; i < successResponse.data.result.length; i++) {
								let product ={
									productId: successResponse.data.result[i].productId,
									name: successResponse.data.result[i].product,
									applyDiscount: successResponse.data.result[i].applyDiscount,
									applyDiscountAsString: successResponse.data.result[i].applyDiscount ? "Yes" : "No",
								}
								this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value.push(product);
							}
						}
						this.loadingFromApi = false;
					},
					errorResponse => {
						this.loadingFromApi = false;
						apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(errorResponse.response.data.responseStatus, errorResponse.response.data.httpStatusCode, errorResponse.response.data.message);
					}
				);
			}
		},
		onLinkProductsClick() {
			this.linkProductsToComboDiscountGroupModal.comboDiscountGroupId = this.comboDiscountGroupId;
			this.linkProductsToComboDiscountGroupModal.showModal = true;
		},
		onLinkProductsToComboDiscountGroupModalCloseClick() {
			this.linkProductsToComboDiscountGroupModal.showModal = false;
			// Only reload if no changes were made through save
		},
		onLinkProductsToComboDiscountGroupSaveClick(comboGroupProductsToSave) {
			console.log("comboGroupProductsToSave", comboGroupProductsToSave);
			this.linkProductsToComboDiscountGroupModal.showModal = false;
			if(comboGroupProductsToSave.productsToUnlink !== null && comboGroupProductsToSave.productsToUnlink.length > 0) {
				if(this.comboGroupProductsToSave.productsToUnlink !== null && this.comboGroupProductsToSave.productsToUnlink !== undefined && this.comboGroupProductsToSave.productsToUnlink.length > 0) {
					this.comboGroupProductsToSave.productsToUnlink = this.comboGroupProductsToSave.productsToUnlink.concat(comboGroupProductsToSave.productsToUnlink);
				}
				else{
					this.comboGroupProductsToSave.productsToUnlink = comboGroupProductsToSave.productsToUnlink;
				}
			}
			this.comboGroupProductsToSave.productsToLink = comboGroupProductsToSave.productsToLink;
			console.log("productsToUnlink", this.comboGroupProductsToSave.productsToUnlink);
			// Update local table data directly instead of API call
			this.updateLocalProductsTable(comboGroupProductsToSave);
		},
		updateLocalProductsTable(productsData) {
			console.log("productsData", productsData);
			if (!productsData) return;
			
			let currentProducts = [...this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value];
			
			// Remove unlinked products
			if (productsData.productsToUnlink && productsData.productsToUnlink.length > 0) {
				const idsToUnlink = productsData.productsToUnlink.map(p => p.productId);
				currentProducts = currentProducts.filter(p => !idsToUnlink.includes(p.productId));
			}
			
			// Add newly linked products
			if (productsData.productsToLink && productsData.productsToLink.length > 0) {
				// Get all available products to extract names and prices
				this.getProductDetailsForNewLinks(productsData.productsToLink, currentProducts);
			} else {
				// If only unlinking, update immediately
				this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value = currentProducts;
			}
		},
		getProductDetailsForNewLinks(productsToLink, currentProducts) {
			// Get all products to find details for the new ones
			let request = {
				allowCollection: true,
				isActive: true
			};
			productService.getProducts(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						const allProducts = successResponse.data.result;
						
						productsToLink.forEach(newProduct => {
							// Check if product is already in the list
							if (!currentProducts.find(p => p.productId === newProduct.productId)) {
								// Find product details from all products
								const productDetails = allProducts.find(p => p.productId === newProduct.productId);
								
								// Create a proper product object for the table
								const productForTable = {
									productId: newProduct.productId,
									name: productDetails ? productDetails.name : `Product ${newProduct.productId}`,
									applyDiscount: newProduct.applyDiscount,
									applyDiscountAsString: newProduct.applyDiscount ? "Yes" : "No",
									// originalPrice: productDetails ? productDetails.price : 0,
									// originalPriceAsString: productDetails ? `R${productDetails.price.toFixed(2)}` : "R0.00",
									// priceAfterDiscount: 0,
									// priceAfterDiscountAsString: "R0.00",
									// discountAmountAsString: "R0.00"
								};
								currentProducts.push(productForTable);
							} else {
								console.log("newProduct", newProduct);
								// Update existing product's applyDiscount flag
								const existingProduct = currentProducts.find(p => p.productId === newProduct.productId);
								if (existingProduct) {
									existingProduct.applyDiscount = newProduct.applyDiscount;
									existingProduct.applyDiscountAsString = newProduct.applyDiscount ? "Yes" : "No";
								}
							}
						});
						
						// Update the form data
						this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value = currentProducts;
						
						// Recalculate prices if discount amount is set
						if (this.comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.value) {
							this.onDiscountAmountChange();
						}
					}
				},
				errorResponse => {
					console.log("error fetching product details", errorResponse);
					// Fallback: add products with minimal info
					productsToLink.forEach(newProduct => {
						if (!currentProducts.find(p => p.productId === newProduct.productId)) {
							const productForTable = {
								productId: newProduct.productId,
								name: `Product ${newProduct.productId}`,
								applyDiscount: newProduct.applyDiscount,
								originalPrice: 0,
								originalPriceAsString: "R0.00",
								priceAfterDiscount: 0,
								priceAfterDiscountAsString: "R0.00",
								discountAmountAsString: "R0.00"
							};
							currentProducts.push(productForTable);
						}
					});
					this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value = currentProducts;
				}
			);
		},
		onProductUnlink(productId) {
			this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value = this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value.filter(p => p.productId !== productId);
			this.comboGroupProductsToSave.productsToLink = this.comboGroupProductsToSave.productsToLink ? this.comboGroupProductsToSave.productsToLink.filter(p => p.productId !== productId) : [];
			if (!this.comboGroupProductsToSave.productsToUnlink) {
				this.comboGroupProductsToSave.productsToUnlink = [];
			}
			this.comboGroupProductsToSave.productsToUnlink.push({
				productId: productId,
				applyDiscount: false
			});
			console.log("productsToUnlink", this.comboGroupProductsToSave.productsToUnlink);
		},
		onDiscountAmountChange() {
			// Update product prices when discount amount changes
			this.comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value.forEach(product => {
				if (product.applyDiscount) {
					product.priceAfterDiscount = product.originalPrice - this.comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.value;
					product.priceAfterDiscountAsString = "R" + product.priceAfterDiscount.toFixed(2);
				}
			});
		},
		onBackClick() {
			this.$router.push("/pricing/combo-discount-groups");
		},
		errorModelOkClicked() {
			this.errorModal.showModal = false;
		},
		successModelOkClicked() {
			this.successModal.showModal = false;
			this.$router.push("/pricing/combo-discount-groups");
		},
		setBreadcrumbs() {
			var pageTitle = "Add Combo Discount Group";
			if(this.isEditMode){
				pageTitle = "Edit Combo Discount Group";
			}
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted() {
		this.comboDiscountGroupId = this.$route.params.comboDiscountGroupId ? parseInt(this.$route.params.comboDiscountGroupId) : null;
		this.isEditMode = this.comboDiscountGroupId != null;
		
		if (this.isEditMode) {
			this.loadComboDiscountGroup();
		}
		this.setBreadcrumbs();
	}
};